{
  "en": {
    "constants": {
      "address": {
        "city": "City",
        "country": "Country",
        "number": "Number",
        "street": "Street",
        "zip": "Post Code"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "currencies": {
        "all": "All currencies",
        "popular": "Popular"
      },
      "days": ["Su", "M", "Tu", "W", "Th", "F", "S"],
      "languages": {
        "de": "German",
        "en": "English",
        "es": "Spanish",
        "fallback_info": "Seems like this is not available in your language. We are using the existing {fallback_locale} translation instead.",
        "fr": "French",
        "it": "Italian",
        "nl": "Dutch",
        "pl": "Polish",
        "pt": "Portuguese"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "it": "IT",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Metric",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "profile_statuses": {
        "active": "Active",
        "added": "Not invited yet",
        "blocked": "Deactivated",
        "discarded": "Deleted",
        "invited": "Invited",
        "invited_at": "Invited"
      },
      "profile_statuses_descriptive": {
        "active": "Last time active on platform: {session_ended_at}",
        "added": "Not invited yet",
        "blocked": "Deactivated",
        "discarded": "Deleted",
        "invited": "Invited but hasn't signed up yet",
        "invited_at": "Invited {invited_at}. Not signed up yet"
      },
      "profile_titles": {
        "dr": "Dr",
        "mr": "Mr",
        "mrs": "Mrs",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Days",
        "months": "Months",
        "weeks": "Weeks"
      },
      "time_units_count": {
        "days": "no day | day | days",
        "months": "no month | month | months",
        "weeks": "no week | week | weeks"
      },
      "timezone_regions": {
        "Africa": "Africa",
        "America": "America",
        "Asia": "Asia",
        "Atlantic": "Atlantic",
        "Australia": "Australia",
        "Europe": "Europe",
        "Pacific": "Pacific"
      },
      "timezones": {
        "Africa/Abidjan": "Africa/Abidjan",
        "Africa/Cairo": "Africa/Cairo",
        "Africa/Casablanca": "Africa/Casablanca",
        "Africa/Johannesburg": "Africa/Johannesburg",
        "Africa/Lagos": "Africa/Lagos",
        "Africa/Nairobi": "Africa/Nairobi",
        "America/Anchorage": "America/Anchorage",
        "America/Bogota": "America/Bogota",
        "America/Buenos_Aires": "America/Buenos Aires",
        "America/Chicago": "America/Chicago",
        "America/Denver": "America/Denver",
        "America/Halifax": "America/Halifax",
        "America/Lima": "America/Lima",
        "America/Los_Angeles": "America/Los Angeles",
        "America/Mexico_City": "America/Mexico City",
        "America/New_York": "America/New York",
        "America/Phoenix": "America/Phoenix",
        "America/Santiago": "America/Santiago",
        "America/Sao_Paulo": "America/São Paulo",
        "America/St_Johns": "America/St. John's",
        "America/Toronto": "America/Toronto",
        "America/Vancouver": "America/Vancouver",
        "Asia/Bangkok": "Asia/Bangkok",
        "Asia/Colombo": "Asia/Colombo",
        "Asia/Dhaka": "Asia/Dhaka",
        "Asia/Dubai": "Asia/Dubai",
        "Asia/Ho_Chi_Minh": "Asia/Ho Chi Minh",
        "Asia/Hong_Kong": "Asia/Hong Kong",
        "Asia/Jakarta": "Asia/Jakarta",
        "Asia/Karachi": "Asia/Karachi",
        "Asia/Kolkata": "Asia/Kolkata",
        "Asia/Kuala_Lumpur": "Asia/Kuala Lumpur",
        "Asia/Makassar": "Asia/Makassar",
        "Asia/Manila": "Asia/Manila",
        "Asia/Riyadh": "Asia/Riyadh",
        "Asia/Seoul": "Asia/Seoul",
        "Asia/Shanghai": "Asia/Shanghai",
        "Asia/Singapore": "Asia/Singapore",
        "Asia/Taipei": "Asia/Taipei",
        "Asia/Tehran": "Asia/Tehran",
        "Asia/Tokyo": "Asia/Tokyo",
        "Atlantic/Reykjavik": "Atlantic/Reykjavik",
        "Australia/Adelaide": "Australia/Adelaide",
        "Australia/Brisbane": "Australia/Brisbane",
        "Australia/Darwin": "Australia/Darwin",
        "Australia/Hobart": "Australia/Hobart",
        "Australia/Melbourne": "Australia/Melbourne",
        "Australia/Perth": "Australia/Perth",
        "Australia/Sydney": "Australia/Sydney",
        "Europe/Amsterdam": "Europe/Amsterdam",
        "Europe/Athens": "Europe/Athens",
        "Europe/Belgrade": "Europe/Belgrade",
        "Europe/Berlin": "Europe/Berlin",
        "Europe/Brussels": "Europe/Brussels",
        "Europe/Bucharest": "Europe/Bucharest",
        "Europe/Budapest": "Europe/Budapest",
        "Europe/Copenhagen": "Europe/Copenhagen",
        "Europe/Dublin": "Europe/Dublin",
        "Europe/Helsinki": "Europe/Helsinki",
        "Europe/Istanbul": "Europe/Istanbul",
        "Europe/Lisbon": "Europe/Lisbon",
        "Europe/London": "Europe/London",
        "Europe/Madrid": "Europe/Madrid",
        "Europe/Moscow": "Europe/Moscow",
        "Europe/Oslo": "Europe/Oslo",
        "Europe/Paris": "Europe/Paris",
        "Europe/Prague": "Europe/Prague",
        "Europe/Rome": "Europe/Rome",
        "Europe/Stockholm": "Europe/Stockholm",
        "Europe/Vienna": "Europe/Vienna",
        "Europe/Warsaw": "Europe/Warsaw",
        "Europe/Zurich": "Europe/Zurich",
        "Pacific/Auckland": "Pacific/Auckland",
        "Pacific/Fiji": "Pacific/Fiji",
        "Pacific/Honolulu": "Pacific/Honolulu"
      },
      "wind_orientations": {
        "east": "East",
        "north": "North",
        "northeast": "North East",
        "northwest": "North West",
        "select": "Select Orientation",
        "south": "South",
        "southeast": "South East",
        "southwest": "South West",
        "west": "West"
      }
    }
  }
}
